import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import {Auth0Plugin} from "./auth";
import HighlightJs from "./directives/highlight";
import "bootstrap/dist/js/bootstrap.bundle";

// import VueVideoPlayer from 'vue-video-player';
// import 'video.js'
// import "videojs-contrib-media-sources"
// import 'video.js/dist/video-js.css';
// import 'videojs-contrib-hls/dist/videojs-contrib-hls';

import {library} from "@fortawesome/fontawesome-svg-core";
import {faChartPie, faInfoCircle, faSyncAlt, faLink, faUser, faRecycle, faPowerOff, faInfo, faExpand, faBan, faCompress, faPlusCircle, faCheck, faCloud, faEdit, faWrench, faExclamationTriangle, faCloudUploadAlt, faCalendar, faSlash, faExpandArrows, faCompressArrows} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

Vue.config.productionTip = false;

// Ensure FontAwesome icons are registered early so icons render reliably
library.add(faChartPie, faInfoCircle, faSyncAlt, faLink, faUser, faPowerOff, faInfo, faEdit, faBan, faCompress, faExpand, faRecycle, faPlusCircle, faCheck, faExclamationTriangle, faSlash, faCloud, faWrench, faCloudUploadAlt, faCalendar);
Vue.component("font-awesome-icon", FontAwesomeIcon);

const allowedScopes = ['syk', 'care-ai'];
const params = new URL(location.href).searchParams;
const scopeParam = params.get('scope');
if (scopeParam && allowedScopes.includes(scopeParam)) {
  // It is in the queryParams so we will set it
  localStorage.setItem("caiScope", scopeParam);
}
const localStorageScope = localStorage.getItem("caiScope");
const scope = localStorageScope ? localStorageScope : 'care-ai';

fetch('auth_config.json')
  .then(response => {
    response.json().then(config => {
      let domain = config.domain;
      let clientId = config.clientId;
      Vue.use(Auth0Plugin, {
        domain,
        clientId,
        onRedirectCallback: appState => {
          router.push(
            appState && appState.targetUrl
              ? appState.targetUrl
              : window.location.pathname
          );
        },
        scope
      });

      Vue.directive("highlightjs", HighlightJs);

      // FontAwesome already registered at startup

      const app = new Vue({
        router,
        render: h => h(App)
      }).$mount("#app");

      // Custom 401 Interceptor
      const globalFetch = global.fetch;
      global.fetch = async (...args) => {
        let [resource, config] = args;
        const response = await globalFetch(resource, config);
        if (response.status === 401) {
          try {
            app.$auth.isAuthenticated = false;
            await app.$auth.logout({ localOnly: true });
            router.replace({ name: 'loggedout' });
          } catch {}
        }
        return response;
      };
    }).catch(err => {
      console.error(err);
    });
  })
  .catch(err => {
    console.error(err);
  })

// Vue.use(Auth0Plugin, {
//   domain,
//   clientId,
//   onRedirectCallback: appState => {
//     router.push(
//       appState && appState.targetUrl
//         ? appState.targetUrl
//         : window.location.pathname
//     );
//   }
// });

// Vue.directive("highlightjs", HighlightJs);
//
// library.add(faLink, faUser, faPowerOff);
// Vue.component("font-awesome-icon", FontAwesomeIcon);
//
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount("#app");


// fetch('/public/config.js')
// .then((json) => {
//   json().then((config) => {
//     Vue.prototype.$config = config
//     new Vue({
//       router,
//       store,
//       render: (h) => h(App)
//     }).$mount("#app");
//   })
// });
